import { INotification } from 'types';
import { getHeaderOptions, getHttpService } from './http-service';

const httpClient = getHttpService();

export const getNotifications = () => {
  return httpClient.get(`/notification/user?all=true`, {
    headers: getHeaderOptions(),
  });
};

export const updateNotification = (payload: INotification) => {
  return httpClient.put('/notification', payload, {
    headers: getHeaderOptions(),
  });
};

export const bulkUpdateNotification = (notifications: INotification[]) => {
  return httpClient.put(
    '/notification/bulk',
    { notifications },
    {
      headers: getHeaderOptions(),
    },
  );
};